import { forwardRef, type Ref, type SVGProps } from "react";
const IconUploadOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M10.71 9.71 15 5.41V23a1 1 0 0 0 2 0V5.41l4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-6-6a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-6 6a1 1 0 0 0 1.42 1.42" />
    <path d="M29 22a1 1 0 0 0-1 1v5H4v-5a1 1 0 0 0-2 0v5.5A1.5 1.5 0 0 0 3.5 30h25a1.5 1.5 0 0 0 1.5-1.5V23a1 1 0 0 0-1-1" />
  </svg>
);
const ForwardRef = forwardRef(IconUploadOutlineSVG);
ForwardRef.displayName = "IconUploadOutline";
export { ForwardRef as IconUploadOutline };
